// extracted by mini-css-extract-plugin
export default {"root":"CellRowGroup-root_tAqwV"};